<template>
  <div>
    <v-toolbar flat color="white">
      <v-btn color="primary" dark class="mb-2" @click="addItem()" round>ADD PACKAGE</v-btn>
      <v-spacer></v-spacer>
      <v-text-field v-model="search" label="Search"></v-text-field>
       <!-- <v-flex xs6 sm3 md3>
        <v-autocomplete
        class="text-xs-center mx-2"
                 clearable
                  hide-no-data
                  flat
                  color="primary"
                  label="Speed"
                  :items="speedProfile"
                  item-text="name"
                  item-value="id"
                  v-model="filterSpeed"
                > </v-autocomplete>
      </v-flex>
      <v-flex xs6 sm3 md3>
        <v-autocomplete
        class="text-xs-center mx-2"
                 clearable
                  hide-no-data
                  flat
                  color="primary"
                  label="Package Type"
                  :items="['Residential', 'Business', 'Other']"
                  item-text="name"
                  item-value="name"
                  v-model="filterPackageType"
                > </v-autocomplete>
      </v-flex>
      <v-flex xs6 sm3 md3>
        <v-btn flat class="primary" round  @click="filterPackages=true">Apply Filter</v-btn>
      </v-flex> -->
    </v-toolbar>

    <!-- Add new item modal -->
    <v-dialog persistent v-model="newDialog" max-width="750px">
      <v-card>
        <v-toolbar flat color="white">
          <v-toolbar-title>Add FNO Package</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn  flat @click="close">X</v-btn>
        </v-toolbar>

        <v-card-text>
          <v-container grid-list-xs>
            <v-layout wrap>
              <v-flex xs12 sm6 md6>
                 <v-select
                 class="text-xs-center mx-2"
                  color="primary"
                  label="*Package Type"
                  :items="['Fibre', 'Wireless']"
                  v-model="editedItem.type"
                > </v-select>
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-autocomplete
                class="text-xs-center mx-2"
                 clearable
                  hide-no-data
                  flat
                  color="primary"
                  label="*Speed Profile"
                  :items="speedProfile"
                  item-text="name"
                  item-value="id"
                  v-model="editedItem.speedProfileId"
                > </v-autocomplete>
              </v-flex>
              <v-flex xs12 sm6 md6>
                 <v-autocomplete
                 class="text-xs-center mx-2"
                 clearable
                  hide-no-data
                  flat
                  color="primary"
                  label="*Package Category"
                  :items="packagesFnoCat"
                  item-text="name"
                  item-value="id"
                  v-model="editedItem.packagesFnoCatId"
                > </v-autocomplete>
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-text-field
                class="text-xs-center mx-2"
                  v-model="editedItem.packageCode"
                  label="Package Code"
                  persistent-hint
                ></v-text-field>
              </v-flex>
               <v-flex xs12 sm6 md6>
                <v-checkbox color="primary" v-model="editedItem.isGlobal" label="Globally Available"></v-checkbox>
              </v-flex>

              <v-flex xs12 sm6 md6>
                <v-text-field
                class="text-xs-center mx-2"
                  v-model="editedItem.packageBasePrice"
                  label="*Package Price"
                  type="number"
                  min="1"
                  step="1"
                  persistent-hint
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-text-field
                class="text-xs-center mx-2"
                  v-model="editedItem.setupFee"
                  label="*Setup Fee Price"
                  type="number"
                  min="1"
                  step="1"
                  persistent-hint
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-text-field
                class="text-xs-center mx-2"
                  v-model="editedItem.layerTwoPortion"
                  label="Layer Two Portion of Base Price"
                  type="number"
                  persistent-hint
                ></v-text-field>
              </v-flex>
                <v-flex xs12 sm6 >
                <v-select @change="editedItem.accountCode = null" :items="['Item', 'Account']" label="Billing Type" v-model="editedItem.accountType"></v-select>
              </v-flex>
              
              <v-flex xs12 sm6 v-if="accountingAccounts.length>0&&editedItem.accountType=='Account'">
                <v-autocomplete :items="accountingAccounts" ref="accountingAccounts" v-on:blur="$refs['accountingAccounts'].blur()" item-text="name" item-value="id" v-model="editedItem.accountCode" label="Accounting Product"></v-autocomplete>
              </v-flex>
              <v-flex xs12 sm6 v-else-if="accountingItems.length>0&&editedItem.accountType=='Item'">
                <v-autocomplete :items="accountingItems" ref="accountingItems" v-on:blur="$refs['accountingItems'].blur()" item-text="name" item-value="id" v-model="editedItem.accountCode" label="Accounting Product"></v-autocomplete>
              </v-flex>
             
              <v-layout justify-center align-center wrap>
                 <v-flex xs12 sm6 md6>
                <v-menu :close-on-content-click="false">
                  <v-text-field
                  class="text-xs-center mx-2"
                    :value="this.editedItem.startDate"
                    slot="activator"
                    label="*Start Date"
                  ></v-text-field>
                  <v-date-picker :close-on-content-click="false" v-model="editedItem.startDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-menu :close-on-content-click="false">
                  <v-text-field
                  class="text-xs-center mx-2"
                    :value="this.editedItem.endDate"
                    slot="activator"
                    label="*End Date"
                  ></v-text-field>
                  <v-date-picker v-model="editedItem.endDate"></v-date-picker>
                </v-menu>
              </v-flex>
              </v-layout>
             
              <!-- <v-flex xs12 sm6 md6>
                <v-switch class="text-xs-center pr-5 pl-3 pt-2" v-model="editedItem.isActive" label="Active"></v-switch>
              </v-flex> -->
            </v-layout>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-layout row justify-center>
          <v-btn v-if="editedItem.type&&editedItem.speedProfileId&&editedItem.packagesFnoCatId&&editedItem.packageBasePrice&&editedItem.startDate&&editedItem.endDate" color="primary" class="white--text" round @click="saveNew">Save</v-btn>
          <v-btn color="primary" class="white--text" round disabled v-else>Save</v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Edit Modal  -->
      <v-dialog persistent v-model="dialog" max-width="750px">
      <v-card>
        <v-toolbar flat class="primary">
          <h1 class="headline white--text">EDIT FNO PACKAGE</h1>
          <v-spacer></v-spacer>
          <v-btn color="white" flat @click="close">X</v-btn>
        </v-toolbar>

        <v-card-text>
          <v-container grid-list-xs>
            <v-layout wrap justify-center>
              <v-flex xs12 sm6 md6>
                 <v-select
                 class="text-xs-center mx-2"
                  color="primary"
                  label="*Package Type"
                  :items="['Fibre', 'Wireless']"
                  v-model="editedItem.type"
                > </v-select>
              </v-flex>
              <v-flex xs12 sm6 md6>
                 <v-autocomplete
                 class="text-xs-center mx-2"
                 clearable
                  hide-no-data
                  flat
                  color="primary"
                  label="*Speed Profile"
                  :items="speedProfile"
                  item-text="name"
                  item-value="id"
                  v-model="editedItem.speedProfileId"
                > </v-autocomplete>
              </v-flex>
              <v-flex xs12 sm6 md6>
                 <v-autocomplete
                 class="text-xs-center mx-2"
                 clearable
                  hide-no-data
                  flat
                  color="primary"
                  label="*Package Category"
                  :items="packagesFnoCat"
                  item-text="name"
                  item-value="id"
                  v-model="editedItem.packagesFnoCatId"
                > </v-autocomplete>
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-text-field
                class="text-xs-center mx-2"
                  v-model="editedItem.packageCode"
                  label="Package Code"
                  persistent-hint
                ></v-text-field>
              </v-flex>
               <v-flex xs12 sm6 md6>
                <v-checkbox color="primary" v-model="editedItem.isGlobal" label="Globally Available"></v-checkbox>
              </v-flex>
              

              <v-flex xs12 sm6 md6>
                <v-text-field
                class="text-xs-center mx-2"
                  v-model="editedItem.packageBasePrice"
                  label="*Package Base Price"
                  type="number"
                  persistent-hint
                ></v-text-field>
              </v-flex>
               <v-flex xs12 sm6 md6>
                <v-text-field
                class="text-xs-center mx-2"
                  v-model="editedItem.setupFee"
                  label="*Setup Fee"
                  type="number"
                  persistent-hint
                ></v-text-field>
              </v-flex>
               <v-flex xs12 sm6 md6>
                <v-text-field
                class="text-xs-center mx-2"
                  v-model="editedItem.layerTwoPortion"
                  label="Layer Two Portion of Base Price"
                  type="number"
                  persistent-hint
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 >
                <v-select :items="['Item', 'Account']" label="Billing Type" v-model="editedItem.accountType"></v-select>
              </v-flex>
              
              <v-flex xs12 sm6 v-if="accountingAccounts.length>0&&editedItem.accountType=='Account'">
                <v-autocomplete :items="accountingAccounts" ref="accountingAccounts" v-on:blur="$refs['accountingAccounts'].blur()" item-text="name" item-value="id" v-model="editedItem.accountCode" label="Accounting Product"></v-autocomplete>
              </v-flex>
              <v-flex xs12 sm6 v-else-if="accountingItems.length>0&&editedItem.accountType=='Item'">
                <v-autocomplete :items="accountingItems" ref="accountingItems" v-on:blur="$refs['accountingItems'].blur()" item-text="name" item-value="id" v-model="editedItem.accountCode" label="Accounting Product"></v-autocomplete>
              </v-flex>
              
              <v-flex xs12 sm6 md6>
                <v-menu :close-on-content-click="false">
                  <v-text-field
                  class="text-xs-center mx-2"
                    :value="formatDate(this.editedItem.startDate)"
                    slot="activator"
                    label="*Start Date"
                  ></v-text-field>
                  <v-date-picker v-model="editedItem.startDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-menu :close-on-content-click="false">
                  <v-text-field
                  class="text-xs-center mx-2"
                    :value="formatDate(this.editedItem.endDate)"
                    slot="activator"
                    label="*End Date"
                  ></v-text-field>
                  <v-date-picker v-model="editedItem.endDate"></v-date-picker>
                </v-menu>
              </v-flex>  
              <v-flex xs6>
                <v-switch label="Active" v-model="editedItem.isActive"></v-switch>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>

        <v-card-actions>
           <v-layout row justify-center>
            <!-- <v-btn color="primary" class="white--text" round @click="close">Cancel</v-btn> -->
          <v-btn color="primary" class="white--text" round @click="save">Save</v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- ///////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
    <v-data-table
      :headers="headers"
      class="elevation-1"
      :search="search"
      :expand="expand"
      :pagination.sync="pagination"
      :loading="isLoading"
      :items="packagesFno"
      :rows-per-page-items="[25, 50, 100, 250]"
      item-key="id"
      align-center
    >
      <template v-slot:items="props">
        <td class="justify-center layout px-0">
          <v-icon small class="mr-2" @click="editItem(props.item)">edit</v-icon>
          <v-icon small @click="deleteItem(props.item.id)">delete</v-icon>
        </td>
        <td class="text-xs-center">{{props.item.packageCode}}</td>
        <td class="text-xs-center">{{props.item.speedProfile.name}}</td>
        <td class="text-xs-center">{{props.item.packagesFnoCat.name}}</td>
        <td class="text-xs-center">{{props.item.packageBasePrice | currency}}</td>
        <!-- <td class="text-xs-center">{{props.item.layerTwoPortion | currency}}</td> -->
        <!-- <td class="text-xs-center">{{formatDate(props.item.startDate)}}</td>
        <td class="text-xs-center">{{formatDate(props.item.endDate)}}</td> -->
        <td class="text-xs-center" v-if="props.item.isGlobal">
          <v-icon color="green">done</v-icon>
          </td>
          <td class="text-xs-center" v-else>
          <v-icon color="red">not_interested</v-icon>
          </td>
        <td class="text-xs-center" v-if="props.item.isActive&&new Date(props.item.startDate) <= new Date()&&(props.item.endDate==null||new Date(props.item.endDate) >= new Date())">
          <v-icon color="green">done</v-icon>
          </td>
          <td class="text-xs-center" v-else>
          <v-icon color="red">not_interested</v-icon>
          </td>
        <!-- <td class="text-xs-center"><v-chip>{{props.item.type}}</v-chip></td> -->
        <td class="text-xs-center"><v-chip>{{props.item.serviceAccounts}}</v-chip></td>
        <td class="text-xs-center">{{props.item.endDate}}</td>




          
      </template>
      <!-- Custom Row count and Paging text -->
      <template
        v-slot:pageText="props"
      >Records {{ props.pageStart }} - {{ props.pageStop }} of {{ props.itemsLength }}</template>
      <!-- No data Dispalay -->
      <!-- <template v-slot:no-data>
        <v-alert :value="true" color="error" icon="warning">Sorry, nothing to display here :(</v-alert>
      </template> -->
    </v-data-table>
  </div>
</template>
 ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
<script>
import Api from "@/services/Api";
import format from "date-fns/format";
import dateformat from 'dateformat';
export default {
  data() {
    return {
      accountingAccounts: [],
      accountingItems: [],
      showDetails: true,
      loading: false,
      isLoading: true,
      filterPackages: false,
      filterSpeed: null,
      filterPackageType: null,
      expand: false,
      speedProfiles:[],
      search: "",
      dialog: false,
      newDialog: false,
      pagination: {},
      headers: [
        {
          text: "Action",
          align: "center"
        },
        {
          text: "Package Code",
          align: "center",
          value: "packageCode"
        },
        {
          text: "Speed Profile",
          align: "center",
          value: "speedProfile.name"
        },
        {
          text: "Category",
          align: "center",
          value: "packagesFnoCat.name"
        },
        {
          text: "Base Price Ex VAT",
          align: "center",
          value: "packageBasePrice"
        },
        // {
        //   text: "Layer Two Portion Ex VAT",
        //   align: "center",
        //   value: "layerTwoPortion"
        // },
        // {
        //   text: "Start Date",
        //   align: "center",
        //   value: "startDate"
        // },
        // {
        //   text: "End Date",
        //   align: "center",
        //   value: "endDate"
        // },
        {
          text: "Globally Available",
          align: "center",
          value: "isGlobal"
        },
        {
          text: "Is Active",
          align: "center",
          value: "isActive"
        },
        {
          text: "Active Accounts",
          align: "center",
          value: "serviceAccounts"
        }
        ,
        {
          text: "Expiry Date",
          align: "center",
          value: "endDate"
        }
      ],
      packagesFno: [],
      packagesFnoCat: [],
      speedProfile: [],
      editedIndex: -1,
      editedItem: {
        packageCode: "",
        speedProfileId:null,
        packagesFnoCatId:null,
        isGlobal: false,
        packageBasePrice: 0,
        setupFee: 0,
        layerTwoPortion: 0,
        startDate: "",
        endDate: "",
        isActive: true,
        isDeleted: false
      },
      defaultItem: {
        packageCode: "",
        speedProfileId:"",
        packagesFnoCatId:"",
        isGlobal: false,
        packageBasePrice: 0,
        setupFee: 0,
        layerTwoPortion: 0,
        startDate: "",
        endDate: "",
        isActive: true,
        isDeleted: false
      }
    };
  },
  computed: {
    pages() {
      if (
        this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      )
        return 0;
      return Math.ceil(
        this.pagination.totalItems / this.pagination.rowsPerPage
      );
    }
  },
  watch: {
    filterPackages(value){
      const route= {
        name:this.$route.name
      }
      if(value===true){

        route.query={
        fnoSpeedProfileId: this.filterSpeed,
        fnoPackageType: this.filterPackageType
        }        
        this.$router.push(route);

          Api()
        .get('/packagesFnos', {
          params:{
            speedProfileId: this.filterSpeed,
            packageType: this.filterPackageType
          }
        }).then(response => {
          this.packagesFno = response.data;
          this.isLoading=false
          }),
       
        this.filterPackages=false
        
        }
    },
    dialog(val) {
      val || this.close();
    },
  },
  async created() {
    let route = await this.$store.state.currentOrg.org.permissions.filter(function(el){
        return el.url === '/packagesFno'})
      if (route.length > 0) {
      await this.$store.dispatch("setCurrentRoute", route[0]);
      if (this.authRead(this.$store.state.currentRoute) === true) {
        this.initialize();
      }
    } else {
      this.$router.push({ name: "SplashPage" });
    }
  },
// //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  methods: {
    
    fetchPackagesFno() {
      this.isLoading=true
      Api()
        .get("/packagesFnos")
        .then(response => {
          this.packagesFno = response.data;
          this.isLoading=false
        });
    },
    initialize() {
      this.fetchPackagesFno();
      this.fetchPackagesFnoTypes();
      this.fetchSpeedProfiles();
     if(this.$store.state.currentOrg.org.accountingSystem == 'SageOne'){
        this.fetchSageAccounts()
        this.fetchSageItems()
      } else if(this.$store.state.currentOrg.org.accountingSystem == 'Xero'){
        this.fetchXeroAccounts()
        this.fetchXeroItems()
      } 
    },
    async fetchSageAccounts(){
      await Api().get('/sageOne/accounts').then(res=>{
        let result = res.data.Results.filter(x=>x.Category.ID == 1)
        this.accountingAccounts = result.map(x=>({id: x.ID.toString(), name: x.Name}))
      })
    },
    async fetchSageItems(){
      await Api().get('/sageOne/items').then(res=>{
        this.accountingItems = res.data.Results.map(x=>({id: x.ID.toString(), name: x.Code}))
      })
    },
    async fetchXeroAccounts(){
      await Api().get('/xero/accounts').then(res=>{
        let result = res.data.body.accounts
        this.accountingAccounts = result.map(x=>({id: x.code, name: x.name}))
      })
    },
    async fetchXeroItems(){
      await Api().get('/xero/items').then(res=>{
        let result = res.data.body.items

        this.accountingItems = result.map(x=>({id: x.code, name: x.name}))
      })
    },
    formattedDate: function(date) {
      return date ? format(date, "Do MMM YYYY") : "";
    },
    formatDate(date){
      if (date==null){
        return null} else{
          return dateformat(date,'dd/mm/yyyy')
        }
    },
    fetchPackagesFnoTypes() {
      Api()
        .get("/packagesFnoCats/active")
        .then(response => {
          this.packagesFnoCat = response.data;
        });
    },
    fetchSpeedProfiles() {
      Api()
        .get("/speedProfiles/active")
        .then(response => {
          this.speedProfile = response.data;
        });
    },
    editItem(item) {
      if(this.authUpdate(this.$store.state.currentRoute)){
        this.editedIndex = this.packagesFno.indexOf(item);
      
      this.editedItem = Object.assign({}, item);
      if(this.editedItem.startDate!==null){
      this.editedItem.startDate = new Date(this.editedItem.startDate).toISOString().substr(0, 10);
      }
      if(this.editedItem.endDate!==null){
      this.editedItem.endDate = new Date(this.editedItem.endDate).toISOString().substr(0, 10);
      }
      this.dialog = true;
      }
      
    },
    addItem(){
      if(this.authCreate(this.$store.state.currentRoute)){
        this.newDialog=true
      }
    },
    deleteItem(id) {
      if(this.authDelete(this.$store.state.currentRoute)){
        confirm("Are you sure you want to delete this item?") &&
        Api().put("/packagesFnos/" + id, {
          isActive: false,
          isDeleted: true
        }).then(
            Api().get('/packagesFnoLocationNetwork/showByFnoPackages/' + id)
            .then(response=>{
              for(let i=0; i<response.data.length; i++){
                Api().put("/packagesFnoLocationNetwork/" + response.data[i].id, {
               isActive: false,
               isDeleted: true
            })
              }
            })
            .then(response=>{
               Api()
              .get('/packagesIsps/byFnoPackageOnly/' + id)           
              .then(response=>{
                for (let j=0; j<response.data.length;j++){
                  Api()
                  .put('/packagesisps/'+response.data[j].id,{
                    isActive: false,
                    isRegistered: true,
                    isDeleted: true
                  })
                  .then(this.$emit('packagesFnoSaved'),
                   this.$emit("ispPackageAdded"))
                }
              })
            })         
        ).then(response => {
           Api()
          .get("/packagesFnoLocationNetwork/showByFnoPackages/"+id,{
            isActive: false,
            isDeleted: true
          })
       this.fetchPackagesFno();
      })
      }
      
    },
    close() {
      this.dialog = false;
      this.newDialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
    async save() {
      let proceed = true;
       if (this.editedItem.speedProfileId == null) {
        proceed = false;
        confirm("Please select a speed profile.");
      }
       if (this.editedItem.packagesFnoCatId == null) {
        proceed = false;
        confirm("Please select a package category.");
      }
       if (this.editedItem.packageBasePrice == null || this.editedItem.packageBasePrice == '') {
        proceed = false;
        confirm("Please fill in a package base price.");
      }
      // if (this.editedItem.setupFee == null || this.editedItem.setupFee == '') {
      //   proceed = false;
      //   confirm("Please fill in a setup fee.");
      // }
       if (this.editedItem.startDate == "") {
        proceed = false;
        confirm("Please select a start date.");
      }
      if (proceed == true) {
      let packageCode=null
      let speedProfileName=null
      if(!this.editedItem.packageCode){
        await Api()
        .get('/packagesFnoCats/'+this.editedItem.packagesFnoCatId)
        .then(response=>{
          packageCode=response.data[0].code
        });
        await Api()
        .get('/speedProfiles/'+this.editedItem.speedProfileId)
        .then(response=>{
          speedProfileName = response.data.name
        })
        this.editedItem.packageCode=packageCode+" "+speedProfileName
      }
      Api().put("/packagesFnos/" + this.editedItem.id, {
        accountCode: this.editedItem.accountCode,
        accountType: this.editedItem.accountType,
        packageCode: this.editedItem.packageCode,
        startDate: this.editedItem.startDate,
        endDate: this.editedItem.endDate,
        packageBasePrice: this.editedItem.packageBasePrice,
        setupFee: this.editedItem.setupFee,
        layerTwoPortion: this.editedItem.layerTwoPortion,
        speedProfileId: this.editedItem.speedProfileId,
        packagesFnoCatId: this.editedItem.packagesFnoCatId,
        isGlobal: this.editedItem.isGlobal,
        isDeleted: this.editedItem.isDeleted,
        isActive: this.editedItem.isActive,
        type: this.editedItem.type
      }).then(response => {
       this.fetchPackagesFno();
      })
      this.$emit("packagesFnoSaved");   
      this.close();
      Object.assign(this.packagesFno[this.editedIndex], this.editedItem);
      }
    },
    async saveNew() {
        let proceed = true;
        if(!this.editedItem.isGlobal){
          this.editedItem.isGlobal=false
        }
      if (this.editedItem.speedProfileId == null) {
        proceed = false;
        confirm("Please select a speed profile.");
      }
       if (this.editedItem.packagesFnoCatId == null) {
        proceed = false;
        confirm("Please select a package category.");
      }
       if (this.editedItem.packageBasePrice == null) {
        proceed = false;
        confirm("Please fill in a package base price.");
      }
      if (this.editedItem.setupFee == null || this.editedItem.setupFee == '') {
        proceed = false;
        confirm("Please fill in a setup fee.");
      }
       if (this.editedItem.startDate == "") {
        proceed = false;
        confirm("Please select a start date.");
      }
      if (proceed == true) {
      let packageCode=null
      let speedProfileName=null
      if(!this.editedItem.packageCode){
        await Api()
        .get('/packagesFnoCats/'+this.editedItem.packagesFnoCatId)
        .then(response=>{
          packageCode=response.data[0].code
        });
        await Api()
        .get('/speedProfiles/'+this.editedItem.speedProfileId)
        .then(response=>{
          speedProfileName = response.data.name
        })
        this.editedItem.packageCode=packageCode+" "+speedProfileName
      }
      if(!this.editedItem.endDate){
        this.editedItem.endDate=null
      }
      Api().post("/packagesFnos", {
        accountCode: this.editedItem.accountCode,
        accountType: this.editedItem.accountType,
        packageCode: this.editedItem.packageCode,
        startDate: this.editedItem.startDate,
        endDate: this.editedItem.endDate,
        packageBasePrice: this.editedItem.packageBasePrice,
        setupFee: this.editedItem.setupFee,
        layerTwoPortion: this.editedItem.layerTwoPortion,
        speedProfileId: this.editedItem.speedProfileId,
        packagesFnoCatId: this.editedItem.packagesFnoCatId,
        isGlobal: this.editedItem.isGlobal,
        isDeleted: this.editedItem.isDeleted,
        isActive: this.editedItem.isActive,
        type: this.editedItem.type
      }).then(response => {        
       this.fetchPackagesFno();
      })
      this.$emit("packagesFnoSaved");
      this.close();
      }
    }
  }
};
</script>
